const ClassesIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 1200 1200"
      width="1.5rem"
      height="1.5rem"
      {...props}
    >
      <path
        d="m175.5 1035c-6.8438 0-12.328-5.4844-12.328-12.328v-845.34c0-6.7969 5.4844-12.328 12.328-12.328 6.7969 0 12.328 5.5312 12.328 12.328v845.34c0 6.8438-5.5312 12.328-12.328 12.328z"
        fillRule="evenodd"
      />
      <path
        d="m1010.3 1035c-6.8438 0-12.328-5.4844-12.328-12.328v-845.34c0-6.7969 5.4844-12.328 12.328-12.328 6.7969 0 12.328 5.5312 12.328 12.328v845.34c0 6.8438-5.5312 12.328-12.328 12.328z"
        fillRule="evenodd"
      />
      <path
        d="m260.9 586.87c-6.7969 0-12.328-5.5312-12.328-12.328v-397.22c0-6.7969 5.5312-12.328 12.328-12.328s12.328 5.5312 12.328 12.328v397.22c0 6.7969-5.5312 12.328-12.328 12.328z"
        fillRule="evenodd"
      />
      <path
        d="m924.89 586.87c-6.7969 0-12.328-5.5312-12.328-12.328v-397.22c0-6.7969 5.5312-12.328 12.328-12.328s12.328 5.5312 12.328 12.328v397.22c0 6.7969-5.5312 12.328-12.328 12.328z"
        fillRule="evenodd"
      />
      <path
        d="m134.39 86.109c-1.2656 0-2.3438 1.0781-2.3438 2.3438v74.156c0 1.2656 1.0781 2.3438 2.3438 2.3438h931.26c1.2656 0 2.3438-1.0781 2.3438-2.3438v-73.875c-0.09375-1.4062-1.2656-2.625-2.5781-2.625zm931.26 103.55h-931.26c-14.906 0-27-12.094-27-27v-74.156c0-14.906 12.141-27 27-27h931.03c14.578 0 26.812 11.953 27.234 26.625v74.531c0 14.906-12.141 27-27 27z"
        fillRule="evenodd"
      />
      <path
        d="m134.39 1035c-1.2656 0-2.3438 1.0781-2.3438 2.3438v74.156c0 1.2656 1.0781 2.3438 2.3438 2.3438h931.26c1.2656 0 2.3438-1.0781 2.3438-2.3438v-73.922c-0.09375-1.5-1.1719-2.625-2.5781-2.625h-931.03zm931.26 103.55h-931.26c-14.906 0-27-12.141-27-27v-74.156c0-14.906 12.141-27 27-27h931.03c14.859 0 26.812 11.719 27.234 26.672v74.531c0 14.906-12.141 27-27 27z"
        fillRule="evenodd"
      />
      <path
        d="m1010.3 586.87h-834.84c-6.8438 0-12.328-5.5312-12.328-12.328s5.4844-12.328 12.328-12.328h834.84c6.7969 0 12.328 5.5312 12.328 12.328s-5.5312 12.328-12.328 12.328z"
        fillRule="evenodd"
      />
      <path
        d="m592.78 290.02c-35.578 0-64.547 28.922-64.547 64.5s28.969 64.5 64.547 64.5 64.5-28.922 64.5-64.5-28.969-64.5-64.5-64.5zm0 153.71c-49.172 0-89.203-39.984-89.203-89.203 0-49.172 40.031-89.203 89.203-89.203s89.156 39.984 89.156 89.203c0 49.172-39.984 89.203-89.156 89.203z"
        fillRule="evenodd"
      />
      <path
        d="m736.22 586.87c-6.8438 0-12.328-5.5312-12.328-12.328 0-34.828-13.594-67.734-38.297-92.625-24.609-24.609-57.516-38.203-92.578-38.203-72.141 0-130.82 58.688-130.82 130.82 0 6.7969-5.5312 12.328-12.328 12.328-6.7969 0-12.328-5.5312-12.328-12.328 0-85.734 69.75-155.53 155.48-155.53 41.625 0 80.719 16.125 110.06 45.469 29.344 29.625 45.469 68.672 45.469 110.06 0 6.7969-5.5312 12.328-12.328 12.328z"
        fillRule="evenodd"
      />
      <path
        d="m296.16 689.9c-3 0-5.5312 2.5312-5.5312 5.5312v206.06c0 3 2.5312 5.5312 5.5312 5.5312h593.53c3 0 5.2969-2.3438 5.2969-5.2969v-206.34c0-3-2.5312-5.5312-5.5312-5.5312h-593.29zm593.53 241.78h-593.53c-16.641 0-30.188-13.547-30.188-30.188v-206.06c0-16.641 13.547-30.188 30.188-30.188h593.29c16.641 0 30.188 13.547 30.188 30.188v206.29c0 16.5-13.453 29.953-29.953 29.953z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ClassesIcon;
